// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"98014392","885":"c95aac40"}[chunkId] + ".chunk.js";
};